import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { ReferralsService } from "../referrals.service";
import { ReferralReward, ReferralRewardTarget } from "../referrals.interfaces";
import { Coupon } from "../../coupons/services/coupons.interfaces";
import { CouponsService } from "../../coupons/services/coupons.service";
const alertify = require("alertify.js");

@Component({
  selector: "ch-rewards-list",
  templateUrl: "./rewards-list.component.html",
  styleUrls: ["./rewards-list.component.css"],
})
export class ReferralRewardsListComponent implements OnInit {
  public referralProgramId: string;
  public referralRewards: ReferralReward[] = [];
  public showPreviousRefereeRewards: boolean = false;
  public showPreviousReferrerRewards: boolean = false;
  public coupons: Coupon[] = [];
  public loading: boolean;

  constructor(
    private router: Router,
    private service: ReferralsService,
    private couponsService: CouponsService,
    private activatedRoute: ActivatedRoute,
  ) {}

  ngOnInit() {
    alertify.logPosition("bottom right");
    this.loadItems();
    this.loadCoupons();
  }

  private loadItems() {
    this.activatedRoute.queryParamMap
      .map((params: Params) => params.params)
      .subscribe((params) => {
        this.referralProgramId = params["id"];
        if (this.referralProgramId) {
          this.loading = true;
          this.service.getAllReferralRewards(this.referralProgramId).subscribe(
            (res) => {
              this.referralRewards = res.json().sort((a, b) => {
                return (
                  new Date(b.createdAt).getTime() -
                  new Date(a.createdAt).getTime()
                );
              });
              this.loading = false;
            },
            (err) => {
              alertify.error(err);
              this.loading = false;
            },
          );
        }
      });
  }

  public loadCoupons() {
    this.loading = true;
    this.couponsService.getAllCoupons().subscribe(
      (coupons) => {
        this.coupons = coupons.json();
        this.loading = false;
      },
      (err) => {
        this.loading = false;
        this.alertError(err);
      },
    );
  }

  public couponName(id: string) {
    return this.coupons.find(c => c.id === id).name;
  }

  get refereeRewards() {
    return this.referralRewards.filter(
      (r) => r.target === ReferralRewardTarget.REFEREE,
    );
  }

  get activeRefereeReward() {
    return this.refereeRewards.find((r) => !r.deletedAt);
  }

  get nonActiveRefereeRewards() {
    return this.refereeRewards.filter(
      (r) => r.id !== this.activeRefereeReward.id,
    );
  }

  get referrerRewards() {
    return this.referralRewards.filter(
      (r) => r.target === ReferralRewardTarget.REFERRER,
    );
  }

  get activeReferrerReward() {
    return this.referrerRewards.find((r) => !r.deletedAt);
  }

  get nonActiveReferrerRewards() {
    return this.referrerRewards.filter(
      (r) => r.id !== this.activeReferrerReward.id,
    );
  }

  public edit(item: ReferralReward) {
    this.router.navigate(["/admin/referral-rewards/edit"], {
      queryParams: {
        referralProgramId: this.referralProgramId,
        id: item ? item.id : undefined,
      },
    });
  }

  public delete(item: ReferralReward) {
    this.loading = true;
    this.service
      .deleteReferralReward(this.referralProgramId, item.id)
      .subscribe(
        (res) => {
          alertify.success("Referral reward deleted successfully.");
          this.loadItems();
        },
        (err) => {
          this.alertError(err);
          this.loading = false;
        },
      );
  }

  public togglePreviousRefereeRewards() {
    this.showPreviousRefereeRewards = !this.showPreviousRefereeRewards;
  }

  public togglePreviousReferrerRewards() {
    this.showPreviousReferrerRewards = !this.showPreviousReferrerRewards;
  }

  private alertError(error: any) {
    if (!error.error) {
      alertify.error(`There was a ${error.status} error with the request.`);
    } else {
      alertify.error(
        `There was a ${error.status} error with message '${error.error}'.`,
      );
    }
  }
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/referrals/rewards/rewards-list.component.ts